import { ModalTiteledWindow } from "./modalWindow.js";
import { DateSelect } from "../dateSelect.js";
import { Validator } from "../validator.js";
import { ModalConfirm } from "./modalConfirm.js";
import { ModalSelectPupil } from "./modalSelectPupil.js";

export class ModalEditPupilNote extends ModalTiteledWindow {
   constructor(app, initData, onChanged) {
      super();

      this.setTitle('Schüler-Anmerkung <span class="help icon-info" selector=".pupilnote-info"></span>');

      this.app = app;
      this.dm = app.dm;
      this.onChanged = onChanged;
      this.user = this.dm.getUserSelf();

      const defaults = {
         note: '',
         pupilId: false,
         classses: []
      };

      initData.pupilIds = initData.pupilId ? [initData.pupilId] : [];
      //if (initData.classes && initData.classes.length) initData.classId = initData.classes[0];

      this.initData = Object.extend(true, defaults, initData);

      this.elMain = HTMLElement.createFromHTML(`
         <div class="modal-edit-pupil-note">
            <div class="settings-item info"></div>
            <div class="settings-item pupil">
               <div class="title absent">Schüler: </div>
               <div class="content">
                  <div class="name"></div>
                  <i class="icon-plus"></i>
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item date">
               <div class="title"><span>Datum: <span class="date-value"></span></span><span class="help icon-info" selector=".day-absence-date"></span></div>
               <div class="content">
                  <div class="validation-error-message"></div>
               </div>
            </div>
            <div class="settings-item note">
               <div class="title">Bemerkung</div>
               <div class="content">
                  <textarea rows="5" type="text" class="txt-note"></textarea>
               </div>
            </div>
            <div class="settings-item templates">
               <div class="title">Vorlagen</div>
               <div class="content">
                  <div class="actions">
                     <div class="and">und</div>
                     <div class="comma">Komma</div>
                     <div class="delete">🗑️</div>
                  </div>
                  <div class="templates"></div>
               </div>
            </div>
            <div class="buttons bottom-bar">
               <i class="btn-delete icon-trash button-circle"></i>
               <i class="btn-save icon-check button-circle"></i>
            </div>
         </div>
      `);

      let editable = this.initData.creatorId === undefined || this.initData.creatorId === this.user.id;
      this.elMain.querySelector('.btn-save').onclick = () => this.save();

      if (!editable || this.initData.creatorId === undefined) {
         this.elMain.querySelector('.btn-delete').classList.add('disabled');
      }
      else {
         this.elMain.querySelector('.btn-delete').onclick = () => this.delete();
      }

      // Datum
      this.dateSelect = new DateSelect({ range: true , onSelect: (from, to) => this.setDate(from, to) });
      this.dateSelect.setEnabled(editable);
      this.elMain.querySelector('.settings-item.date .content').prepend(this.dateSelect.getElement());

      this.elPupilName = this.elMain.querySelector('.settings-item.pupil .name');
      this.elMain.querySelector('.settings-item.pupil .icon-plus').onclick = () => {
         if (this.initData.classes.length > 0) {
            let pupilIds = this.dm.getClass(this.initData.classes[0]).pupils;
            new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
         }
      }

      this.elNote = this.elMain.querySelector('.settings-item.note textarea');

      this.elMain.querySelectorAll('.settings-item.templates .actions div').forEach(el => el.onclick = (e) => {
         const value = e.currentTarget.getAttribute('class');
         if (value === 'and') this.addTemplate('und');
         else if (value === 'comma') this.addTemplate(',');
         else this.elNote.value = '';
      });


      this.elNote = this.elMain.querySelector('.settings-item.note .txt-note');
      this.elNote.disabled = !editable;

      this.loadData(this.initData);
      this.appendToBody(this.elMain);
      this.setupHelp(this.app);
      setTimeout(() => this.show(), 1);

   }

   async save() {

      let val = new Validator([
         {
               name: 'pupilId',
               element: this.elPupilName,                
               get: () => {
                  return this.initData.pupilIds;
               },
               //validate: { 'id': true },
               error: { element: this.elMain.querySelector('.settings-item.pupil .validation-error-message'), message: "Bitte wählen Sie einen Schüler oder eine Schülerin aus." }
         },
         {
               name: 'date',
               element: this.dateSelect.getElement(),
               get: () => {
                  //const d = this.dateSelect.getSelection();
                  //return { from: d.from.isoDate(), to: d.to.isoDate() }
                  return this.dateSelect.getSelection();
               },
               validate: { 'dateRange': true },
               error: { element: this.elMain.querySelector('.settings-item.date .validation-error-message'), message: "Bitte geben Sie das Datum an." }
         },
         {
               name: 'note',
               element: this.elNote,
               get: () => this.elNote.value
         }
      ]);

      let valiData = val.validate();

      if (valiData) {
         valiData.dateFrom = valiData.date.from.isoDate();
         valiData.dateTo   = valiData.date.to.isoDate();
         delete valiData.date;

         valiData.type = 'pupilNote';

         let data = Object.extend(true, this.initData, valiData);

         if (!data.creatorId) data.creatorId = this.user.id;
         data.lastModifierId = this.user.id;

         for (let pupilId of data.pupilIds) {
            const saveData = Object.extend(true, data, { pupilId: pupilId });
            delete saveData.pupilIds;
            //if (index > 0) saveData.localId = 0, saveData.id = 0;
            saveData.visibleForTeachers = saveData.visibleForPupils = false;
            //console.log(saveData);
            await this.dm.saveClassNote(saveData);
         }

         this.onChanged();
         this.close();

      }

   }

   delete() {

      new ModalConfirm(
         "Soll diese Schüler-Anmerkung wirklich gelöscht werden?",
         async (confirmed) => {
               if (confirmed) {
                  await this.dm.deleteClassNote(this.initData);
                  this.onChanged();
                  this.close();
               }
         }
      );

   }

   setDate(from, to) {
      const elValue = this.elMain.querySelector('.settings-item.date .title .date-value');
      if (!from) elValue.innerHTML = '';
      else if (to && to.getDate() !== from.getDate()) elValue.innerHTML = Date.simplifyDatePeriod(from.isoDate(), to.isoDate());
      else elValue.innerHTML = from.toGermanDate();
   }

   setPupils(pupilIds) {

      for (let pupilId of pupilIds) {
         let pupil = this.dm.getUser(pupilId);
         if (pupil) {
            let elPupil = HTMLElement.createFromHTML(`<div class="pupil"><i class="btn-delete icon-cross"></i><div class="pupil-name">${pupil.lastName}, ${pupil.firstName}</div></div>`);
            this.elPupilName.appendChild(elPupil);
            if (!this.initData.pupilIds.includes(pupilId)) this.initData.pupilIds.push(pupilId);
            elPupil.querySelector('.btn-delete').onclick = (event) => {
               event.stopPropagation();
               this.initData.pupilIds = this.initData.pupilIds.filter(id => id !== pupilId);
               elPupil.remove();
            }
         }
      }

   }

   addTemplate(tpl) {

      if (this.elNote.value.trimEnd().endsWith('.')) this.elNote.value = this.elNote.value.trimEnd().slice(0, -1);
      if (this.elNote.value.length > 0 && tpl !== ',') this.elNote.value += ' ';
      this.elNote.value += tpl;
   }

   loadTemplates() {
      const elTemplates = this.elMain.querySelector('.settings-item.templates .content .templates');

      this.dm.getPupilNoteTemplates().then(templates => {

         for (let tpl of templates) {
            const elTpl = HTMLElement.createFromHTML(`<div class="template">${tpl}</div>`);
            elTpl.onclick = () => {
               this.addTemplate(tpl);
            };
            elTemplates.append(elTpl);
          }
      });
   }   

   loadData(data) {

      if (data.creationTime) {
         const cTime = new Date(data.creationTime*1000);
         const mTime = new Date(data.lastModTime*1000);
         let info = `erstellt am ${cTime.toGermanDate(true)} um ${cTime.format("%H:%i:%s")} von ${this.app.dm.getUser(data.creatorId).short}`
         if (data.creationTime !== data.lastModTime) {
               info += `<br>zuletzt bearbeitet am ${mTime.toGermanDate(true)} um ${mTime.format("%H:%i:%s")}`;
         }
         this.elMain.querySelector('.settings-item.info').innerHTML = info;
      }

      if (data.pupilId === false) {
         if (data.classes && data.classes.length > 0) {
            let pupilIds = this.dm.getClass(data.classes[0]).pupils;
            new ModalSelectPupil({list: pupilIds}, (ids) => this.setPupils(ids), this.dm);
         }
      }
      else {
         this.setPupils(data.pupilIds);
      }

      this.dateSelect.select(data.dateFrom ? new Date(Date.fromString(data.dateFrom)) : false, data.dateTo? new Date(Date.fromString(data.dateTo)) : false);
      this.setDate(new Date(Date.fromString(data.dateFrom)), new Date(Date.fromString(data.dateTo)));
      this.elNote.value = data.note;

      this.loadTemplates();
   }


}

